var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: 260.4172,
    y: 0,
    viewBox: "9.63800048828125 3.246999979019165 80.7239990234375 93.50699615478516",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    height: 247.2,
    width: 213.40619824383663,
    className: "icon-c-0",
    "data-fill-palette-color": "accent",
    id: "c-0",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#026ed9",
    "data-fill-palette-color": "accent"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#026ed9",
    "data-fill-palette-color": "accent"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "36.703,11.011 9.638,26.636 9.638,38.757 36.703,23.131 63.767,38.757 63.767,26.636   ",
    fill: "#026ed9",
    "data-fill-palette-color": "accent"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#026ed9",
    "data-fill-palette-color": "accent"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "63.298,89.092 36.233,73.467 36.233,61.348 63.298,76.973 90.362,61.348 90.362,73.467   ",
    fill: "#026ed9",
    "data-fill-palette-color": "accent"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#026ed9",
    "data-fill-palette-color": "accent"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "9.638,42.012 36.703,26.386 47.198,32.446 20.134,48.072 20.134,79.324 9.638,73.264   ",
    fill: "#026ed9",
    "data-fill-palette-color": "accent"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#026ed9",
    "data-fill-palette-color": "accent"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "77.083,18.872 50.018,3.247 39.522,9.307 66.586,24.932 66.586,56.184 77.083,50.124   ",
    fill: "#026ed9",
    "data-fill-palette-color": "accent"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#026ed9",
    "data-fill-palette-color": "accent"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "23.01,81.127 23.011,49.876 33.507,43.816 33.507,75.068 60.571,90.693 50.075,96.754   ",
    fill: "#026ed9",
    "data-fill-palette-color": "accent"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#026ed9",
    "data-fill-palette-color": "accent"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "90.362,58.092 90.362,26.84 79.866,20.78 79.866,52.031 52.802,67.658 63.298,73.719   ",
    fill: "#026ed9",
    "data-fill-palette-color": "accent"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLight);
export default __webpack_public_path__ + "static/media/logo-light.1ae4f26201c6a7b71f7e9026c00ad134.svg";
export { ForwardRef as ReactComponent };